// Internal modules
import { CountryCodes } from '@/generated/graphql';

// Buyer country/locale can come in as the legacy 'C2' code for China;
// normalize to the standard 'CN' ISO code before using it downstream.
export const normalizeCountryCode = (country: CountryCodes): CountryCodes =>
  country === CountryCodes.C2 ? CountryCodes.Cn : country;

// Locale strings can carry the legacy 'C2' country suffix (e.g. 'zh_C2');
// normalize it to the standard 'CN' suffix before using it downstream.
export const normalizeLocale = (locale: string): string => {
  const legacySuffix = `_${CountryCodes.C2}`;
  return locale.endsWith(legacySuffix)
    ? `${locale.slice(0, -legacySuffix.length)}_${CountryCodes.Cn}`
    : locale;
};
